import styles from "./BreakLineTool.module.scss";

export default class BreakLineTool {
  public data;
  static get toolbox() {
    return {
      title: "BreakLine",
      icon: '<i class="fas fa-angle-double-down" style=height:12px></i>',
    };
  }

  constructor({ data }: any) {
    this.data = data;
  }

  render() {
    const wrapper = document.createElement("div");
    wrapper.classList.add("cdx-block");
    wrapper.classList.add(styles["breakLine-wrapper"]);
    const icon = document.createElement("i");
    icon.className = "fas fa-angle-double-down";
    wrapper.appendChild(icon);
    this.data = { breakLine: true };
    return wrapper;
  }

  save() {
    return this.data;
  }

  destroy() {
    this.data = null;
  }
}
